// extracted by mini-css-extract-plugin
export var addToCartButton = "_kx-b";
export var arrowButtonContainer = "_kx-9";
export var arrowButtonIcon = "_kx-a";
export var carouselArrowButton = "_kx-6";
export var carouselElementContainer = "_kx-1";
export var left = "_kx-7";
export var productDisplayCarouselContainer = "_kx-0";
export var productTileContainer = "_kx-2";
export var productTileImage = "_kx-4";
export var productTileImageContainer = "_kx-3";
export var productTileTitle = "_kx-5";
export var right = "_kx-8";
export var sliderOverflow = "_kx-c";